import React from "react";
import classNames from "classnames";

export default function ToggleSwitch({ value, onChange, options }) {
  return (
    <div className="d-flex align-items-center border rounded-pill">
      {options.map((option) => (
        <div
          key={option.value}
          className={classNames('flex-fill text-center py-2 rounded-pill cursor-pointer', {'kg-bg-green text-white': value === option.value})}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
}
